import {
  RESET_USERS,
  RESET_USER,
  RESET_ERROR,
  GET_USERS,
  SET_USERS,
  API_ERROR,
  GET_USER,
  SET_USER,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_PASSWORD,
  EDIT_PASSWORD_SUCCESS,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  GET_USERS_FORM,
  SET_USERS_FORM,
  GET_USER_SUMMARY_SETTINGS,
} from "./actionTypes";

export const resetUsers = () => {
  return {
    type: RESET_USERS,
    payload: {},
  };
};

export const resetUser = () => {
  return {
    type: RESET_USER,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getUsers = (page, qnt, name, email, externalId, filters) => {
  return {
    type: GET_USERS,
    payload: { page, qnt, name, email, externalId, filters },
  };
};

export const setUsers = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_USERS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createUser = (newUserValues) => {
  return {
    type: CREATE_USER,
    payload: { newUserValues },
  };
};

export const createUserSuccess = (message) => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: { message },
  };
};

export const getUser = (idUser, isForm) => {
  return {
    type: GET_USER,
    payload: { idUser, isForm },
  };
};

export const getUserSummarySettings = (idUser, isForm) => {
  return {
    type: GET_USER_SUMMARY_SETTINGS,
    payload: { idUser, isForm },
  };
};

export const setUser = (data) => {
  return {
    type: SET_USER,
    payload: { data },
  };
};

export const editUser = (idUser, newUserValues) => {
  return {
    type: EDIT_USER,
    payload: { idUser, newUserValues },
  };
};

export const editPassword = (idUser, password) => {
  return {
    type: EDIT_PASSWORD,
    payload: { idUser, password },
  };
};

export const editPasswordSuccess = (message) => {
  return {
    type: EDIT_PASSWORD_SUCCESS,
    payload: { message },
  };
};

export const editUserSuccess = (message) => {
  return {
    type: EDIT_USER_SUCCESS,
    payload: { message },
  };
};

export const activateUser = (idUser, active) => {
  return {
    type: ACTIVATE_USER,
    payload: { idUser, active },
  };
};

export const activateUserSuccess = (message) => {
  return {
    type: ACTIVATE_USER_SUCCESS,
    payload: { message },
  };
};

export const getUsersForm = () => {
  return {
    type: GET_USERS_FORM,
    payload: {},
  };
};

export const setUsersForm = (data) => {
  return {
    type: SET_USERS_FORM,
    payload: { ...data },
  };
};
